export function throttle(func: Function, ms: number): () => void {
  let isThrottled: boolean = false;

  return () => {
    if (isThrottled) {
      return;
    }

    func();

    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;
    }, ms);
  };
}
